import * as userGendoer from '@/constants/userGender'

export const getGender = (gender: string) => {
  switch (gender) {
    case userGendoer.GENDER_F:
      return userGendoer.GENDER_F_TEXT

    case userGendoer.GENDER_M:
      return userGendoer.GENDER_M_TEXT

    default:
      return ''
  }
}
